import m from "./../../../dist/es2015/locales/hr_HR.js";
export const am5locales_hr_HR = m;